import React from 'react';

import { useTranslation } from 'react-i18next/';
import { useParams } from 'react-router-dom';

import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';

import { Container, LoadingSpinner } from '@ttstr/components';

import { confirmSubscription } from '@ttstr/api';

interface RouterParams {
  token: string;
}

const NewsletterSubscribeFinisher: React.FC = () => {
  const { t } = useTranslation();
  const [success, setSuccess] = React.useState<boolean>(null);
  const [processing, setProcessing] = React.useState<boolean>(true);
  const params = useParams<RouterParams>();

  async function confirmNewsletter(token: string) {
    try {
      await confirmSubscription(token);
    } catch (error) {
      setProcessing(false);
      setSuccess(false);
    } finally {
      setProcessing(false);
      setSuccess(true);
    }
  }

  React.useEffect(() => {
    confirmNewsletter(params.token);
  }, []);

  return (
    <article className="mt-5 newsletter-unsubscribe-finisher">
      <Container>
        <h1 className="text-center mb-4">You are now subscribed</h1>
        <Row>
          <Col>
            {processing ?? <LoadingSpinner label={t('CUSTOMER.CONFIRM.CONFIRMING')} />}
            {success ?? (
              <Row>
                <Col lg={{ size: 6, offset: 3 }}>
                  <p className="text-justify text-center">
                    Thank you for subscribing! We hope you have a great time. You can unsubscribe anytime.
                  </p>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Container>
    </article>
  );
};

export default React.memo(NewsletterSubscribeFinisher);
